var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from "react";
import { useUpdateEffect } from "react-use";
export var usePagination = function (props) {
    var _a = __read(React.useState(props.page), 2), page = _a[0], setPage = _a[1];
    var _b = __read(React.useState(props.rowsPerPage), 2), rowsPerPage = _b[0], setRowsPerPage = _b[1];
    var skip = page * rowsPerPage;
    var onChangePage = function (event, newPage) {
        setPage(newPage);
    };
    var onChangeRowsPerPage = function (event) {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    useUpdateEffect(function () {
        setPage(0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, props.pageResetDeps);
    return { page: page, rowsPerPage: rowsPerPage, onChangePage: onChangePage, onChangeRowsPerPage: onChangeRowsPerPage, skip: skip };
};
